<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msg" :mensagem="msg" />

    <div v-if="!modoArquivos" class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.id) }}</div>
            </div>

            <div class="form-item-data">
                <label class="label-caption">Data</label>
                <input type="date" v-model="objEdicao.dtpasta" />
            </div>

            <div class="form-item-char40">
                <DriveGrupoSelect v-model:idSelecionado="objEdicao.iddrivegrupo" />
            </div>

            <div class="form-item">
                <label class="label-caption">Nome</label>
                <input type="text" v-model="objEdicao.nmpasta" required maxlength="200" v-uppercase />
            </div>
        </div>

        <div v-if="props.ckPublica=='N'">
            <SimSelect v-model:idSelecionado="objEdicao.idsim" />

        </div>

        <div class="row-end">
            <label for="ckAtivo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>

    <div v-if="modoArquivos">
        <DriveArquivoTabPage :idPasta="idDrivePasta" @close="closeFromArquivo"></DriveArquivoTabPage>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarDrivePasta } from '@/models/drivePasta';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import DriveArquivoTabPage from './DriveArquivoTabPage.vue';
import DriveGrupoSelect from '@/selects/DriveGrupoSelect.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import SimSelect from '@/components/selects/SimSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({
    idEdicao: {type: Number, default: 0},
    ckPublica: {type: String, default: 'N'}});

const ckAtivo = ref(false);
const idDrivePasta = ref(0);
const isLoading = ref(false);
const modoArquivos = ref(false);
const msg = ref(null);
const objEdicao = ref(criarDrivePasta());


const cancelForm = () => {emit('close');}


function closeFromArquivo(){
    emit('save');
    emit('close');
}


const lerDados = async() => {
    try{
        isLoading.value = true;
        msg.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('drive/pasta', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msg.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
            objEdicao.value.idlogin     = globalStore.idlogin;
            objEdicao.value.ckpublica   = props.ckPublica;
        }
        objEdicao.value.idusuario       = globalStore.idusuario;
        ckAtivo.value                   = objEdicao.value.ativo === 'S';        
    } catch (error) {msg.value = error;
    }finally{isLoading.value=false;}
}

const salvarDados = async() => {
    if (!objEdicao.value.iddrivegrupo) {msg.value='Informe o grupo'; return;}
    if (!objEdicao.value.nmpasta || objEdicao.value.nmpasta.trim() === '') {msg.value='Informe o nome da pasta'; return;}
    try {
        isLoading.value             = true;
        msg.value                   = null;
        objEdicao.value.ativo       = ckAtivo.value ? 'S' : 'N';
        const response              = await Api.genericPut('/cad/drive/pasta', objEdicao.value);
        if (response.bolok === 1){
            idDrivePasta.value = response.id;
            modoArquivos.value = true;
        }else{
            msg.value = response.erro;
        }
    } catch (error) {msg.value = error;
    } finally{isLoading.value=false;}
}

onMounted(lerDados)
</script>